import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pr-range',
  templateUrl: './pr-range.component.html',
  styleUrls: [],
  standalone: false
})
export class PRRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
